import React, { useState } from 'react';
import { parseLocation } from 'shared/components/hawksearch/util/QueryString';
import MagnifyingGlassSVG from 'shared/components/svg/MagnifyingGlassSVG';

interface LandingPageSearchBoxProps {
	placeholder?: string;
}

const searchRequest = parseLocation(location);

function LandingPageSearchBox(props: LandingPageSearchBoxProps) {
	const { placeholder } = props;

	const [inputValue, setInputValue] = useState('');

	function handleSubmit(keywords: string) {
		redirectToSearchPage(keywords);
	}

	function redirectToSearchPage(keywords: string | null) {
		let redirect = searchRequest.CustomUrl ?? '';
		if (keywords) {
			redirect += `?keyword=${encodeURIComponent(keywords ?? '')}`;
		}

		location.assign(redirect);
	}

	return (
		<div className="hawk-search-form" data-testid="global-search-box">
			<input
				className="hawk-search-form__input"
				type="text"
				onChange={(e) => setInputValue(e.currentTarget.value)}
				onKeyDown={(event) => {
					if (event.key === 'Enter') {
						handleSubmit(inputValue || '');
					}
				}}
				placeholder={placeholder}
			/>
			<button
				type="button"
				className="hawk-search-form__btn"
				onClick={() => {
					handleSubmit(inputValue ?? '');
				}}
				data-testid="global-search-button"
			>
				<MagnifyingGlassSVG className="hawk-search-form__input-icon" />
				<span className="roc-visually-hidden">Search</span>
			</button>
		</div>
	);
}

export default LandingPageSearchBox;
